import parseLocaleString from 'rlink-regions/parseLocaleString';

export default function getClosestSupportedLanguage (supportedLanguages, preferredLanguages) {
  let preferredLanguage;
  for (preferredLanguage of preferredLanguages) {
    if (supportedLanguages.includes(preferredLanguage)) {
      return preferredLanguage;
    }
  }

  for (preferredLanguage of preferredLanguages) {
    for (let supportedLanguage of supportedLanguages) {
      if (preferredLanguage) {
        let locale = preferredLanguage.split('-');
        if (parseLocaleString(supportedLanguage).languageCode === locale[0]) {
          return supportedLanguage;
        }
      }
    }
  }

  return supportedLanguages[0];
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getClosestSupportedLanguage.js